export default __webpack_public_path__ + "static/media/orange_drop.7af6570c.svg";